import React from "react";
import {Form, InputNumber, Modal} from "antd";
import {FormModalProps} from "../../../../utils/useFormModal";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal title={'修改赠品余量'} {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'qty'} label={'数量'} rules={[{required: true, message: '请输入数量'}]}>
                    <InputNumber precision={2} style={{width: '100%'}}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
